import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/util/auth'
import {Message} from 'element-ui'

const user = {
  namespaced: true,
  state: {
    token: getToken(),
    name: '',
    nickName:'',
    avatar: '',
    adminRole: null,
    userId: 0,
    permissions:''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_NICK_NAME: (state, nickName) => {
      state.nickName = nickName
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ADMIN_ROLE: (state, adminRole) => {
      state.adminRole = adminRole
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_USERID:(state,userId)=>{
      state.userId = userId
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const code = userInfo.code
      const uuid = userInfo.uuid
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid).then(res => {
          if (res.ok) {
            setToken(res.data.token);
            commit('SET_TOKEN', res.data.token);
            getInfo().then(re => {
              resolve(re.data);
            })
          } else {
            Message({type : "error", message: res.msg});
            reject();
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          const user = res.data;
          const avatar = (user.avatar == "" || user.avatar == null) ? require("@/assets/profile.jpg") : user.avatar;
          commit('SET_NAME', user.username)
          commit('SET_NICK_NAME', user.nickName)
          commit('SET_AVATAR', avatar)
          commit('SET_USERID',user.userId)
          commit('SET_ADMIN_ROLE', user.adminRole)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_PERMISSIONS', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
